import { Directive, computed, input } from '@angular/core';
import {mergeClasses} from '../../utils';

@Directive({
  selector: 'label[zLabel]',
  host: { '[class]': 'classes()', 'data-slot': 'label' },
})
export class UiLabel {
  readonly class = input<string>('');
  readonly classes = computed(() => mergeClasses(
    "flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
    this.class(),
  ));
}
